import { get } from 'lodash';
import { CLIENT_IFRAME_ID } from 'admin/constants/common';

/**
 * @return {{contentDocument: *, contentWindow: *}|{}}
 */
export function getClientFrame() {
	if (typeof document === 'undefined') {
		console.error('document is undefined');
		return {};
	}
	const frame = document.getElementById(CLIENT_IFRAME_ID) as HTMLIFrameElement;

	return {
		contentDocument: get(frame, 'contentDocument'),
		contentWindow: get(frame, 'contentWindow'),
		frame,
	};
}

export function getClientFrameNode(id: string) {
	return getClientFrame().contentDocument?.getElementById(id);
}

export function getClientFrameNodeStyles(id: string) {
	const frame = getClientFrame();
	const node = frame.contentDocument?.getElementById(id);
	return node ? frame.contentWindow!.getComputedStyle(node) : ({} as CSSStyleDeclaration);
}
